export default __webpack_public_path__ + "static/media/Ranjith_Resume.522e89d3.pdf";